import * as actionTypes from '../actions/actionTypes';
import axios from 'axios';

const API_KEY = "7033825bfe31262791b5"; //https://www.currencyconverterapi.com/docs
const CURRENCY_TYPE = "USD_UZS,RUB_UZS"; //https://www.currencyconverterapi.com/docs

export const createCurrency = (data) => {
    return {
        type: actionTypes.CREATE_CURRENCY,
        data
    }
}


export const fetchInitialRate = () => {
    return dispatch => {
        axios.get(`//free.currconv.com/api/v7/convert?q=${CURRENCY_TYPE}&compact=ultra&apiKey=${API_KEY}`)
            .then(res => {
                return dispatch(createCurrency({ ...res.data }))
            })
            .catch(err => console.log(err))
    }
}